import { useQuery } from "react-query";
import { getHierarchyTypes } from "actions/CarrierAgreementMgmt/Hierarchy";

export const useGetHierarchyTypes = () => {
  return useQuery("GetHierarchyTypes", getHierarchyTypes, {
    refetchOnWindowFocus: false,
  });
};
